module.exports = require("@tiptap/react");